
const imageUrl = (title) => {
  return `/imgs/solution/logistics/${title}.png`;
};

const data = {
  banner: {
    title: '综合物流服务解决方案',
    description: '提供智能化、平台化、数字化、信息化的多式联运综合物流解决方案。',
    bg: imageUrl('banner')
  },
  method: imageUrl('method'),
  advantage: [
    {
      img: imageUrl('advantage1'),
      title: '专业交付',
      description: '团队成员从事供应链、物流信息化行业超过15年，积累了丰富的开发、实施经验，实现快速专业交付。'
    },
    {
      img: imageUrl('advantage2'),
      title: '可拓展性',
      description: '控制塔可实现客户端、供应商端接口拓展交互，并支持对大数据平台，电子合同等功能的拓展。'
    },
    {
      img: imageUrl('advantage3'),
      title: '可定制化',
      description: '支持高度定制化，个性化需求轻松配置实现，打造您专属的物流系统。'
    },
    {
      img: imageUrl('advantage4'),
      title: '智能自动化',
      description: '智能配载、自动派单、自动计费等智能自动化功能，助力降本增效。'
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Solution/config/logistics.js